import { useAccount, useReadContracts } from 'wagmi';
import { erc20Abi } from 'viem';
import useGetUserAddress from 'src/hooks/useGetUserAddress';

interface Props {
  tokenAddresses: `0x${string}`[];
  chainId?: number;
  intervalTime?: number;
  enabled?: boolean;
}

export function useMultipleErc20Balances({
  tokenAddresses,
  chainId,
  intervalTime,
  enabled = true,
}: Props) {
  const { address: userAddress } = useAccount();
  const { address } = useGetUserAddress();

  const walletAddress = userAddress ?? address;
  const contracts = tokenAddresses
    .filter((item) => !!item)
    .map((token) => ({
      abi: erc20Abi,
      address: token,
      functionName: 'balanceOf',
      args: [walletAddress],
      chainId,
    }));

  const result = useReadContracts({
    contracts,
    allowFailure: true,
    query: {
      enabled: enabled,
      refetchInterval: intervalTime,
    },
  });

  return result;
}
